import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { notification } from 'antd'
import { useTranslation } from 'react-i18next'
import {
    fetchWhatsappBusinessAccount,
    fetchWhatsappBusinessAccounts,
    syncWhatsappBusinessAccount,
} from './whatsapp-business-account-api'

export function useWhatsappBusinessAccounts({ enabled }: { enabled?: boolean } = {}) {
    return useQuery({
        queryFn: fetchWhatsappBusinessAccounts,
        queryKey: ['whatsapp-business-accounts'],
        enabled: enabled,
    })
}

export function useWhatsappBusinessAccount(accountId?: string | null) {
    return useQuery({
        queryFn: () => fetchWhatsappBusinessAccount(accountId!),
        queryKey: ['whatsapp-business-accounts', accountId],
        enabled: !!accountId,
    })
}

export function useSyncWhatsappBusinessAccount(accountId?: string | null) {
    const queryClient = useQueryClient()
    const { t } = useTranslation()

    return useMutation({
        mutationFn: () => syncWhatsappBusinessAccount(accountId!),
        onSuccess: () => {
            notification.success({
                message: t('WhatsApp business account synced'),
                description: t('Phone numbers and templates have been synced successfully'),
            })
            queryClient.invalidateQueries({ queryKey: ['whatsapp-business-accounts', accountId] })
            queryClient.invalidateQueries({ queryKey: ['phone-numbers', accountId] })
            queryClient.invalidateQueries({ queryKey: ['message-templates'] })
        },
    })
}
